<template>
  <div id="card-user-view">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <div class="flex-grow">
              <h4>免許・資格</h4>
            </div>
            <vs-button
              class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              icon-pack="feather"
              icon="icon-plus"
              color="primary"
              type="filled"
              :to="{
                name: 'enterprise-management-license-add',
                params: { userId: $route.params.userId }
              }"
              >新しい免許・資格を登録する</vs-button
            >
          </div>
          <vs-divider />
        </div>
      </div>
      <div class="vx-row" v-if="licenses">
        <div
          class="vx-col w-full sm:w-1/2 lg:w-1/5 mb-base"
          v-for="license in licenses"
          :key="license.id"
        >
          <card-license :data="license" @updateLicenses="updateLicenses"></card-license>
        </div>
      </div>
      <div class="mt-4 mb-4" v-if="licenses.length === 0">
        <span class="text-lg leading-none"
          >登録されている免許・資格はありません</span
        >
      </div>
    </vx-card>
  </div>
</template>

<script>
import CardLicense from "@/components/card/CardLicense";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserView");

export default {
  components: { CardLicense },
  computed: {
    ...mapState({
      licenses: state => state.licenses
    })
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["fetchLicenses"]),

    updateLicenses() {
      this.fetchLicenses(this.$route.params.userId);
    }
  }
};
</script>

<style lang="scss">
  //プレビューのとき重なりの順序を変更するためz-indexを指定
  .vue-lb-container {
    z-index: 100000;
  }
</style>
